export const ISSUE_DETAILS = 'ISSUE_DETAILS' as const;

export type PanelType = typeof ISSUE_DETAILS | undefined;
